import { Accordion, Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { formatDate } from "../../../../Utils/Common";
import RecruitedDonorAccordion from "./RecruitedDonor";
import SpecialDonorRequestsAccordion from "./SpecialDonorRequestsAccordion";
import StoolAccordion from "./StoolAccordion";
import SkinTapeAccordion from "./SkinTapeAccordion";
import HairFollicleAccordion from "./HairFollicleAccordion";
import BuccalSwabAccordion from "./BuccalSwabAccordion";
import UrineAccordion from "./UrineAccordion";
import BloodSampleAccordion from "./BloodSampleAccordion";
import ExhaledBreathAccordion from "./ExhaledBreathAccordion";
import SalivaAccordion from "./SalivaAccordion";
import ExcludedDonorsAccordion from "./ExcludedDonorsAccordion";
import { useEffect, useState } from "react";
import Loader from "../../../../Components/Loader";
import { SampleService } from "../../../../Services/Sample.service";
const SampleTypeRequestedAccordion = ({ type,sampleRequestDetails, sampleTypeData, cancelAppointment, isCollectSample, selectedRecruitedDonor, acceptedSamples, collectSample }) => {
    useEffect(()=>{ 
        //console.log(acceptedSamples);
    },[acceptedSamples]);

    const [loading, setLoading] = useState(false);
    const [raceList, setRaceList] = useState([]); // Store race options from API
    
    const getRaceOptions = async () => {
        const result = await SampleService.getRaceOptions();
        if (result.success) {
            console.log("race options retrived sucessfully");
            setRaceList(result.race_option);

            // Extract and set heritage types separately
            const single = result.race_option.find(option => option.type_id === 1);
            const dual = result.race_option.find(option => option.type_id === 2);

            console.log("single", single); console.log("dual", dual);


            // setSingleHeritage(single ? single.race_options.map(r => r.heritage_name) : []);
            // setDualHeritage(dual ? dual.race_options.map(r => r.heritage_name) : []);
        
        }
        else {
            console.log("failed while getting race options")
        }
    }

    useEffect(() => {
        getRaceOptions();
    }, [sampleRequestDetails]);

    return (
        <>
            {/* <Accordion className="accordion-item" flush> */}
            <Loader loading={loading} /> 
                <Accordion.Item eventKey="3">
                    <Accordion.Header>
                        <b>Sample Types Requested: {sampleRequestDetails?.request?.rq_samples.length || '-'}</b> <br className="d-md-none d-block" />
                        {sampleRequestDetails?.request?.matched_sample != 'no' ? (<span className="badge text-bg-danger ms-3 p-2 btn bg-danger">
                            <i className="el-icon-match"></i> Job contains matched samples
                        </span>) : ''}

                    </Accordion.Header>

                    <Accordion.Body className="accordion accordion-flush" id="accordionFlushExample1" >
                        
                    <Accordion className="accordion-item" defaultActiveKey={["6","7","8", "9"]} alwaysOpen flush>
                            <>
                        {isCollectSample !== true && (
                                <RecruitedDonorAccordion type={type} sampleRequestDetails={sampleRequestDetails} sampleTypeData={sampleTypeData} cancelAppointment={cancelAppointment} setLoading={setLoading}/>
                            )}
                                {sampleRequestDetails?.request?.is_special_donor && ( //for admin and requestor View details not showing SpecialDonorRequestsAccordion if no any special donor
                                    <>
                                        <SpecialDonorRequestsAccordion
                                            hasSpecialRequests={sampleRequestDetails?.request?.is_special_donor}
                                            sampleRequestDetails={sampleRequestDetails?.request}
                                            preferredDonorIds={JSON.parse(sampleRequestDetails?.request?.special_donor_ids || null)}
                                            alternate_donor_ids={JSON.parse(sampleRequestDetails?.request?.alternate_donor_ids || null)}
                                        /> 
                                    </>
                                )}
                                {sampleRequestDetails?.request?.is_exclude_donors && (   //for admin View details not showing ExcludedDonorsAccordion if no any excluded donor
                                    <>
                                {/* {type==='requestor' && (  */}
                                        <ExcludedDonorsAccordion
                                            isExcludeDonors={sampleRequestDetails?.request?.is_exclude_donors}
                                            excludedDonorIds={JSON.parse(sampleRequestDetails?.request?.excluded_donor_ids || null)}
                                            type={type}
                                            /> 
                                {/* )} */}
                                    </>
                                )}  
                            
                            </>
                       

                        {/* {acceptedSamples.length > 0 ? (<>
                        
                        </>) : (<> */}
                        
                            {  sampleRequestDetails?.request?.rq_samples?.map((sample) => 
                                { 
                                    const recruitedDonor = sampleRequestDetails?.request?.recruited_donors.filter(recruitedDonor =>
                                        recruitedDonor.accepted_samples.split(',').map(id => id.trim()).includes(sample.sample_id.toString())
                                    );
                                    const isMatched = sampleRequestDetails?.request?.matched_sample == "no" ? false : true;
                                if (!acceptedSamples || acceptedSamples.length === 0 || acceptedSamples.includes(sample.sample_id)) {
                                return sample.sample_id === 1 ? <BloodSampleAccordion key={`sample-${sample.sample_id}`} id={1} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched} selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                    sample.sample_id === 2 ? <UrineAccordion key={`sample-${sample.sample_id}`} id={2} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched}  selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                        sample.sample_id === 3 ? <ExhaledBreathAccordion key={`sample-${sample.sample_id}`} id={3} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched}  selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}></ExhaledBreathAccordion> :
                                            sample.sample_id === 4 ? <SalivaAccordion key={`sample-${sample.sample_id}`} id={4} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched}  selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}> </SalivaAccordion> :
                                                sample.sample_id === 5 ? <BuccalSwabAccordion key={`sample-${sample.sample_id}`} id={5} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched} selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                                    sample.sample_id === 6 ? <HairFollicleAccordion key={`sample-${sample.sample_id}`} id={6} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched} selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                                        sample.sample_id === 7 ? <SkinTapeAccordion key={`sample-${sample.sample_id}`} id={7} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched} selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                                            sample.sample_id === 8 ? <StoolAccordion key={`sample-${sample.sample_id}`} id={8} sampleRequestDetails={sample} recruitedDonor={recruitedDonor } isCollectSample={isCollectSample} isMatched={isMatched} selectedRecruitedDonor={selectedRecruitedDonor} collectSample={collectSample}  type={type}  raceList={raceList}/> :
                                                                '' } })}
                        {/* </>)} */}



                        {/* {sampleRequestDetails?.request?.samples?.map((sample) => (
                                                    sampleAccordionComponents[sample.sample_id] || null
                                                ))} */}
                        {/* {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((sample) => (
                                                    sampleAccordionComponents[sample] || null
                                                ))} */}



                        {/* <Accordion className="accordion-item" flush>
                                                    <Accordion.Item eventKey="2">
                                                        <Accordion.Header>Excluded Donors</Accordion.Header>
                                                        <Accordion.Body>
                                                            <div className="el-property-details-card-content">
                                                                <Row>
                                                                    <Col md={12} className="mx-fit-content">
                                                                        <div className="flex-sec justify-content-between col-xxl-6"> 
                                                                            <div className="el-flex-area mb-3 mb-lg-0">
                                                                                <div className="el-content-detail">
                                                                                    <p className="el-request-detail-profile-title">Donor ID</p>
                                                                                    <h4 className="el-request-detail-profile-name">
                                                                                        <a href="#">1234567890</a>
                                                                                    </h4>
                                                                                </div>
                                                                            </div> 
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion> */}
                                                </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
            {/* </Accordion> */}
        </>
    );
}

export default SampleTypeRequestedAccordion 



 